
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";
import { MatRadioModule } from "@angular/material/radio";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FormsModule } from "@angular/forms";
import { Choice } from "../../../../polls/polls.type";
import { QuestionForPreview } from "app/frontend/lib/polls/create-poll/create-poll.type";

@Component({
    selector: "five-stars-question",
    templateUrl: "./five-stars-question.component.html",
    styleUrls: [".././poll-request.component.scss", "./five-stars-question.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    FormsModule,
    MatRadioModule,
    MatTooltipModule
]
})
export class FiveStarsQuestionComponent implements OnChanges {
    
    protected userAnswerId: string;
    protected possibleAnswers: Choice[];
    
    @Input() question: QuestionForPreview;

    @Output() onAnswerChange = new EventEmitter<any>();

    constructor(){}

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.question.currentValue){
            this.possibleAnswers = this.question.choices.sort((a, b) => a.position - b.position);
            this.userAnswerId = undefined;
        }
    }

    changeAnswer(id: string){
        this.userAnswerId = id;
        this.onAnswerChange.emit(id);
    }

}